// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Table, TableRow, TableHeader as Header, TableBody as Body } from 'common/components/Tables';
import LoadingSpinner from 'common/components/LoadingSpinner';

const SpinnerWrapper = styled.td`
`;

const STable = styled(Table)`
  table-layout: fixed;
  min-width: ${({ minWidth }) => minWidth || 0}px;
`;

const TableHeader = styled(Header)`
  background-color: ${({ theme }) => theme.colors.primary};

  tr {
    height: 48px;
  }

  td {
    color: ${({ theme }) => theme.colors.tertiaryText};
  }
`;

const TableBody = styled(Body)`
  tr {
    height: 56px;
  }
`;

export const TableContent = styled.td`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  font-size: ${({ theme }) => theme.fonts.style.midSmall.fontSize}px;
`;

export const SRow = styled(TableRow)`
  cursor: pointer;

  :hover {
    background-color: ${({ theme: { colors } }) => colors.hexToRGBA(colors.primary, 0.1)};
  }
`;

const NoData = styled.td`
  height: 56px;
  justify-content: center;
  align-items: center;
`;

type HeaderProp = {
  [key: string]: string | number
}

type Props<T> = {
  headers: string[],
  headersProps?: HeaderProp[],

  data: T[],
  renderRow: (item: T) => SRow,

  noDataMessage: string,
  loading?: boolean,
}

export default function DataTable<T>({ headers, headersProps, data, renderRow, noDataMessage, loading }: Props<T>) {
  return (
    <STable>
      <TableHeader>
        <TableRow>
          {
            headers.map((header, i) => {
              const props = headersProps ? headersProps[i] : {};
              return <TableContent key={header} {...props}>{header}</TableContent>;
            })
          }
        </TableRow>
      </TableHeader>
      <TableBody>
        {loading &&
        <SRow>
          <SpinnerWrapper colSpan={headers.length}>
            <LoadingSpinner />
          </SpinnerWrapper>
        </SRow>
        }
        {!loading && data.length === 0 &&
        <SRow>
          <NoData colSpan={headers.length}>{noDataMessage}</NoData>
        </SRow>
        }
        {!loading && data.length > 0 && data.map(item => renderRow(item))}
      </TableBody>
    </STable>
  );
}



// WEBPACK FOOTER //
// ./src/common/components/DataTable.js